export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-light-8c5bb0c704f351a20230c2ab988004a180ac7cf5dbe9a390e974776fa278ae59.png";